webpackJsonp([261083256674194],{

/***/ 399:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var icon1 = "https://www.winpeforum.com/assets/elements/AishwaryaJaishanker.jpg";
	var icon2 = "https://www.winpeforum.com/assets/elements/AparnaJain.png";
	var icon3 = "https://www.winpeforum.com/assets/elements/DivyaIyer.jpg";
	var icon4 = "https://www.winpeforum.com/assets/elements/KhushbooShahani.png";
	var icon5 = "https://www.winpeforum.com/assets/elements/KiranSharma.jpg";
	var icon6 = "https://www.winpeforum.com/assets/elements/KritiGupta.png";
	var icon7 = "https://www.winpeforum.com/assets/elements/KritikaAgarwal.jpg";
	var icon8 = "https://www.winpeforum.com/assets/elements/SanjnaTulsiani.png";
	var icon9 = "https://www.winpeforum.com/assets/elements/ShraddhaBanka.jpg";
	var icon10 = "https://www.winpeforum.com/assets/elements/SurbhiGarg.jpg";
	var icon11 = "https://www.winpeforum.com/assets/elements/VarunaKhattri.jpg";
	
	var mentConstant4 = [{
	  imgUrl: icon1,
	  desc: "Aishwarya Jaishankar is co-founder and COO of Hyperface Technologies, a Fintech Infrastructure company that helps banks and brands create compelling credit programs. A veteran digital banker by background, Aishwarya has a track record of disruptive banking product development and scaling. She has played key roles in digital transformation success stories at large banks prior to starting up. A leading product voice in multiple Fintech events, she is an executive committee member of IFTA.\n         ",
	  name: "Aishwarya Jaishanker",
	  company: "-",
	  post: "-",
	  oldpost: "Co-founder & COO",
	  oldcompany: "Hyperface Technologies",
	  linkedIn: "https://www.linkedin.com/in/aishwarya-jaishankar/?originalSubdomain=in"
	}, {
	  imgUrl: icon2,
	  desc: "Aparna joined Multiples in 2020, in the portfolio management function and transitioned into the investor relations & fund-raising role in 2023. Prior to Multiples she spent 4+ years in the Financial Advisory practice at EY & Deloitte focussing on transactions along-side business risk consulting. She also worked with CRISIL (S&P) as part of their global Structured Finance team for rating Asset Backed Securities in North America. By way of education, she is a Chartered Accountant and holds a certificate The Wharton School, University of Pennsylvania for completing the executive course on \u2018Leadership & Management in New Age Business\u2019. She completed her articleship from PWC Assurance \u2013 Financial Services alongside pursuing her Bachelors from H.R. College of Commerce & Economics.<br/><br/>\nThroughout her prior stints she has focused on developing a multi-faceted understanding of businesses and growth accelerators in different sectors  and fostered an approach to analyse facts in-depth before decision making while empathising with stakeholder concerns. In her current role, she focuses on investor engagements and strategic developments at Multiples.\nHer interests include reading about history, culture and non-fiction content exploring human behaviour. She also enjoys travelling and painting.\n         ",
	  name: "Aparna Jain",
	  company: "Brookfield Renewable",
	  post: "Associate Director - Portfolio Management",
	  oldpost: " AVP",
	  oldcompany: "Multiples PE",
	  linkedIn: "https://www.linkedin.com/in/aparna-jain-38813180/?originalSubdomain=in"
	}, {
	  imgUrl: icon4,
	  desc: "Khushboo Shahani Khushboo Shahani is an Executive Director at Eversource Capital, specializing in investments in energy efficiency, resource efficiency, and e-mobility. With over 13 years of experience in alternative asset classes, she has overseen nearly USD 1 billion in investments across private equity, private credit, and special situations. At Eversource, Khushboo focuses on scaling investments in the circular economy and climate impact sectors. Her previous roles include Vice President at Everstone Capital Advisors, where she led deployments of over USD 150 million, and Chief Manager at SBI Funds Management, where she executed distressed transactions with targeted IRRs of 18-22%. Khushboo holds an MBA from SP Jain Institute of Management & Research and a Bachelor of Commerce from St. Francis College for Women, Hyderabad.\n\n         ",
	  name: "Khushboo Shahani",
	  company: "-",
	  post: "-",
	  oldpost: "Executive Director",
	  oldcompany: "Eversource Capital",
	  linkedIn: "https://www.linkedin.com/in/khushbooshahani/?originalSubdomain=in"
	}, {
	  imgUrl: icon5,
	  desc: "As a Senior Investment Analyst at Accion Emerge, Kiran is a global investment professional with extensive expertise in early-stage investments across emerging and frontier markets. Her career encompasses significant experience in valuation and financial modeling, and she has a strong track record in investment evaluation, deal execution, portfolio management, business advisory services, and business development. Kiran has led advisory groups providing technical and business assistance to manage growth and operational turnarounds.<br/><br/>\nPreviously, Kiran worked at Deloitte India in the Financial Services practice, specializing in business valuation and financial modeling. She holds an MBA from Narsee Monjee Institute of Management Studies. Kiran's key areas of expertise include financial modeling, investor relations, business valuations, and transaction advisory. Outside of work, she enjoys reading non-fiction books, traveling, and practicing origami.\n\n\n         ",
	  name: "Kiran Sharma",
	  company: "-",
	  post: "-",
	  oldpost: "Senior Specialist Investment & Portfolio Management  ",
	  oldcompany: "Accion Emerge",
	  linkedIn: "https://www.linkedin.com/in/kiran-sharma-she-her-822a4956/"
	}, {
	  imgUrl: icon6,
	  desc: "Kriti is a Venture Capital professional with a background in engineering from IIT Bombay and an MBA from Harvard Business School. She co-founded an AgTech startup during her undergraduate years, which, despite not taking off, provided her with valuable insights into the challenges founders face in building businesses from scratch. Her career began at Deutsche Bank, but her passion for the startup ecosystem led her to venture capital. Kriti has worked with a domestic VC firm and Silicon Valley funds focused on India, culminating in her current role at Peak XV Partners.\nKriti is drawn to founders with deep passion, high emotional intelligence, and an intimate understanding of the problems they aim to solve. She believes the best founders channel their industry experiences into a relentless drive to create transformative solutions, inspiring others through their vision. Kriti seeks to partner with such visionaries to help build enduring, impactful businesses\n\n\n         ",
	  name: "Kriti Gupta",
	  company: "-",
	  post: "-",
	  oldpost: "Vice President",
	  oldcompany: "Peak XV",
	  linkedIn: "https://www.linkedin.com/in/kriti-gupta-50b58062/"
	}, {
	  imgUrl: icon7,
	  desc: "Kritika Agarwal has over a decade of experience and is part of the Firm\u2019s Corporate Group. Kritika\u2019s practice focuses on advising multinational clients on acquisitions, divestitures, joint ventures, strategic alliances, and general corporate and commercial strategy.\n\n         ",
	  name: "Kritika Agarwal",
	  company: "-",
	  post: "-",
	  oldpost: "Partner",
	  oldcompany: "AZB & Partners",
	  linkedIn: "https://www.linkedin.com/in/kritika-agarwal-377021119/?originalSubdomain=in"
	}, {
	  imgUrl: icon8,
	  desc: "Sanjna has 8+ years of experience across venture growth investing, investor relations and equity research. Prior to joining Iron Pillar, Sanjna worked in a senior leadership role at Valorem Advisors, consulting at the CXO level for publicly listed companies, strategically advising them and representing their interests in the investor community. Sanjna has also worked at Morgan Stanley Capital International, where she was involved in the creation, rebalancing, and restructuring of public market indexes for developed & emerging markets. Sanjna is a CFA® Charter holder. She holds a Masters in Commerce (Finance & Accounting) and Bachelors in Management Studies (Finance) from the University of Mumbai.",
	
	  name: "Sanjna Tulsiani",
	  company: "Iron Pillar Fund",
	  post: "Senior Vice President- Investments",
	  oldpost: "Vice President",
	  oldcompany: "Iron Pillar Fund",
	  linkedIn: "https://www.linkedin.com/in/sanjna-t-9a7b9963/"
	}, {
	  imgUrl: icon9,
	  desc: "Shraddha is Associate Vice President - Compliance at Lighthouse. Before joining Lighthouse, Shraddha worked with the Audit and Assurance Services Practice of KPMG, where she handled audits, tax and compliance-related assurance engagements of companies across sectors, including financial services and manufacturing.\nShraddha is a commerce graduate from the University of Mumbai.\n\n         ",
	  name: "Shraddha Banka",
	  company: "-",
	  post: "-",
	  oldpost: "AVP - Compliance",
	  oldcompany: "Lighthouse Funds",
	  linkedIn: "https://www.linkedin.com/in/shraddha-b-a28967141/"
	}, {
	  imgUrl: icon10,
	  desc: "Surbhi is Vice President at Trifecta Capital, where she leads growth investments in technology companies across consumer internet, fintech, and healthtech sectors. Prior to Trifecta, she was with Reliance Jio Strategic Investments leading tech acquisitions across India, Israel, and US. She started her investing journey at GenNext Venture Fund where she established a Jerusalem-based startup incubator and helped set up Jio GenNext's accelerator program in partnership with Microsoft. Her passion lies in working with founders to build category-defining companies and establishing strong governance frameworks.<br/><br/>\nSurbhi is a silver medalist from BITS Pilani in Electrical Engineering and holds an MBA from IIM Bangalore. She is an international award winner in painting and enjoys mentoring early-stage founders in their entrepreneurial journey.\n\n\n         ",
	  name: "Surbhi Garg",
	  company: "-",
	  post: "-",
	  oldpost: "VP",
	  oldcompany: "Trifecta Capital",
	  linkedIn: "https://www.linkedin.com/in/surbhi-garg-12475517/"
	}, {
	  imgUrl: icon11,
	  desc: "Varuna Khattri, based in Mumbai, Maharashtra, India, is an Investment Professional at CPP Investments. With a diverse professional background, Varuna has held roles at Shapoorji Pallonji and Company Limited, the Asian Center for Entertainment Education, Takshashila Consulting, and HSBC\u2019s Investment Banking division. Varuna earned a PGDM in Finance from the Indian Institute of Management, Shillong (2011\u20132013). Equipped with a strong skill set, including expertise in mathematics, writing, root cause analysis, luxury management, consulting, and more, Varuna brings valuable insights to the field.\n\n         ",
	  name: "Varuna Khattri",
	  company: "-",
	  post: "-",
	  oldpost: "Senior Associate",
	  oldcompany: "CPP Investments",
	  linkedIn: "https://www.linkedin.com/in/varunakhattri/?originalSubdomain=in"
	},,];
	
	exports.default = mentConstant4;
	module.exports = exports["default"];

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Index = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(576);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentConstant = __webpack_require__(399);
	
	var _mentConstant2 = _interopRequireDefault(_mentConstant);
	
	var _Media = __webpack_require__(38);
	
	var _MediaRight = __webpack_require__(55);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'head_section' },
	        _react2.default.createElement(
	          'span',
	          { className: 'item_name' },
	          activeItem.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.post
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'item_des' },
	          activeItem.company
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'cross pull-right' },
	        _react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'item__desc force-overflow' },
	        _react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var Index = exports.Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(args) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      activeItem: {},
	      isShow: false
	    };
	
	    return _this;
	  }
	
	  Index.prototype.render = function render() {
	    var _this2 = this;
	
	    var location = this.props.location;
	    var isShow = this.state.isShow;
	
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentees: Cohort of 2024', description: 'A group of highly talented young women on their path to continued success.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
	      _react2.default.createElement(
	        'div',
	        { className: 'mentees-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'heading' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Mentees ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('span', null),
	              ' Cohort V'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section_intro_text' },
	            'A group of highly talented young women on their path to continued success.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _mentConstant2.default.map(function (item, i) {
	              if (i >= 9) return _react2.default.createElement(
	                'div',
	                { className: '  col-sm-12 col-md-12  ' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner', onClick: function onClick() {
	                        return _this2.togglePopUp(item);
	                      } },
	                    _react2.default.createElement('img', {
	                      className: 'imagess', style: { width: "200px", height: "200px", objectFit: "cover" }, src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Previous Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Current Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                )
	              );else return _react2.default.createElement(
	                'div',
	                { className: 'col-sm-6 col-md-4' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'circle-card' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'card-inner' },
	                    _react2.default.createElement('img', { className: 'imagess', src: item.imgUrl }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'overlayy' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cercle' },
	                      '\xA0'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'circle-name' },
	                        item.name,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Previous Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldpost,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.oldcompany,
	                        ' '
	                      ),
	                      _react2.default.createElement('hr', null),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        _react2.default.createElement(
	                          'b',
	                          null,
	                          'Current Profile'
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.post,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'post' },
	                        item.company,
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'a',
	                        { target: '_blank', href: item.linkedIn, className: 'linkedinbtn btn btn-primary btn-sm' },
	                        _react2.default.createElement('i', { className: 'fa fa-linkedin' })
	                      )
	                    )
	                  )
	                ),
	                ' '
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Index;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-v-index-js-691d6d6768a4750bbc9b.js